import { useOutletContext } from 'react-router-dom';
import { WuwEvent } from '@packages/types';

export type EventOutletContext = { event: WuwEvent };

/** Access the loaded event from any nested event-microsite route. */
export const useEvent = () => useOutletContext<EventOutletContext>().event;
